import {styled} from '@mui/styles';
import React from 'react';
import {formatCurrency} from '../utilities';

const Holder = styled('span')(({theme}) => ({
  fontFamily: theme.typography.fixedWidth,

  '&.finalised': {
    fontWeight: 600,
  }
}));

const Value = ({value, currency, finalised}) => (
  <Holder {...(finalised ? {className: 'finalised'} : {})}>{currency ? formatCurrency(value, currency) : value}</Holder>
)

export default Value;
